export default __webpack_public_path__ + "static/media/DragDrop.c35d67fc.svg";